export default __webpack_public_path__ + "static/media/Facebook.1b6476f3.svg";